// extracted by mini-css-extract-plugin
export default {"container":"DriverNote_container__UCB8O","note":"DriverNote_note__dxucY"};